// extracted by mini-css-extract-plugin
export default {"paypal":"Paypal_paypal__80cnR","paypalFrame":"Paypal_paypalFrame__VjqJ6","payNow":"Paypal_payNow__aBdrt","spinner":"Paypal_spinner__CE6c8"};